export default __webpack_public_path__ + "static/media/signmeup.14847920.png";